var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58333 3.83325C5.31 3.83325 5.08333 3.60659 5.08333 3.33325V1.33325C5.08333 1.05992 5.31 0.833252 5.58333 0.833252C5.85667 0.833252 6.08333 1.05992 6.08333 1.33325V3.33325C6.08333 3.60659 5.85667 3.83325 5.58333 3.83325Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 3.83325C10.6433 3.83325 10.4167 3.60659 10.4167 3.33325V1.33325C10.4167 1.05992 10.6433 0.833252 10.9167 0.833252C11.19 0.833252 11.4167 1.05992 11.4167 1.33325V3.33325C11.4167 3.60659 11.19 3.83325 10.9167 3.83325Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 15.1666H5.58333C3.15 15.1666 1.75 13.7666 1.75 11.3333V5.66659C1.75 3.23325 3.15 1.83325 5.58333 1.83325H10.9167C13.35 1.83325 14.75 3.23325 14.75 5.66659V11.3333C14.75 13.7666 13.35 15.1666 10.9167 15.1666ZM5.58333 2.83325C3.67667 2.83325 2.75 3.75992 2.75 5.66659V11.3333C2.75 13.2399 3.67667 14.1666 5.58333 14.1666H10.9167C12.8233 14.1666 13.75 13.2399 13.75 11.3333V5.66659C13.75 3.75992 12.8233 2.83325 10.9167 2.83325H5.58333Z",
    fill: "#26B5ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 7.83325H5.58333C5.31 7.83325 5.08333 7.60659 5.08333 7.33325C5.08333 7.05992 5.31 6.83325 5.58333 6.83325H10.9167C11.19 6.83325 11.4167 7.05992 11.4167 7.33325C11.4167 7.60659 11.19 7.83325 10.9167 7.83325Z",
    fill: "#26B5ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.1666H5.58333C5.31 11.1666 5.08333 10.9399 5.08333 10.6666C5.08333 10.3933 5.31 10.1666 5.58333 10.1666H8.25C8.52333 10.1666 8.75 10.3933 8.75 10.6666C8.75 10.9399 8.52333 11.1666 8.25 11.1666Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteText);
export default __webpack_public_path__ + "static/media/note-text.b7dc425c11c88b2078b27342db05ac2d.svg";
export { ForwardRef as ReactComponent };